
import ApexCharts from 'apexcharts';
import { PubSub, Auth } from 'aws-amplify';

import { GoogleApiWrapper, InfoWindow, Map } from 'google-maps-react';
import React, { Component } from 'react';
import truck_green_temp_blue from '../images/truck_green_temp_blue.png';
import truck_green_temp_red from '../images/truck_green_temp_red.png';
import truck_green_temp_yellow from '../images/truck_green_temp_yellow.png';
import truck_red_temp_blue from '../images/truck_red_temp_blue.png';
import truck_red_temp_red from '../images/truck_red_temp_red.png';
import truck_red_temp_yellow from '../images/truck_red_temp_yellow.png';
import TrucksTable from '../components/TrucksTable';
import VehicleChart from '../components/VehicleChart';
import { queryTimestreamData, queryTimestreamDevicesAll, queryLastKnownPosition, parseTimestreamTime } from '../services/timestream';

const mapStyles = {
  width: '100%',
  height: '100%'
};


// Add CSS for fade animation
const style = document.createElement('style');
style.textContent = `
  .marker-fade {
    animation: fade 2s infinite;
  }
  @keyframes fade {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
  }
`;
if (!document.head.querySelector('style[data-marker-fade]')) {
  style.setAttribute('data-marker-fade', 'true');
  document.head.appendChild(style);
}

const MapaCentro = 
{
    lat: -10.2004,
    lng: -48.3233
};

const ReducedLabelsMapStyle = [
  { featureType: 'all', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'all', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', stylers: [{ visibility: 'on' }] },
  { featureType: 'administrative', stylers: [{ visibility: 'on' }] }
];

// Tópico MQTT: Simemap/<tenant>/<cidade>/<n>/<device_id>/mtudata/log
// Cobre todos os tenants (Hefesto, paodahora, Alisson, POC) de uma vez.
const TOPIC_ALL = 'Simemap/+/+/+/+/mtudata/log';
// Restrito a um device: tenant/cidade/n variam por device, só o id é conhecido.
const topicForDevice = (id) => `Simemap/+/+/+/${id}/mtudata/log`;

//exemplo de tópico/payload:
// Simemap/Hefesto/Florianopolis/19/smc3pxq/mtudata/log
// {
//   "device_id": "smc3pxq",
//   "v_fw": "4.2.1",
//   "PCB": "MTU",
//   "vehicle_plate": "OLN5270",
//   "latitude": -10.165926933288574,
//   "longitude": -48.318069458007812,
//   "altitude": 270.29,
//   "velocity": 0,
//   "temper": [
//     {
//       "id": "fb3c01f095f37828",
//       "value": -2,
//       "voltage": 3896,
//       "m_c": 2073,
//       "lora_rssi": -77
//     }
//   ],
//   "SD_saved": 0,
//   "heap": 34728,
//   "heap_min": 29164,
//   "last_reset": 1769503679,
//   "reset_reason": 3,
//   "sent_over": "gsm",
//   "timestamp": 1769504614,
//   "timezone": -180,
//   "cloud_m_c": 15
// }

export class MapContainer extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            stores: [],
        }
    }

    state = {
        showingInfoWindow: false,
        activeMarker: {},
        selectedPlace: {},
        selectedStoreIndex: null,
        temperaturas: {},
        lat: {},
        lng: {},
        currentBoardSelected: {
            temperatures: []
        },
        stores: [],
        temperaturaParaOChart: 0,
        selectedVehicle: null,
        selectedDeviceId: null,
        chartLoadingFromParent: false,
        vehicleChartData: [],
        // true quando o período do gráfico termina em "agora": novos dados do
        // tópico MQTT são acrescentados ao gráfico em tempo real
        chartLive: true,
        hoverTimestamp: undefined
    };
    
    // onVehicleSelect = (vehiclePlate) => {
    onVehicleSelect = (device_id, vehicle_plate) => {
        const plateOrId = vehicle_plate || device_id;
        const rows = Array.isArray(this.state.stores) ? this.state.stores : [];
        let store = rows.find(s => s?.device_id === device_id);
        if (!store && plateOrId) {
          store = rows.find(s => s?.vehicle_plate === plateOrId || s?.NameDevice === plateOrId);
        }
        const lat = store?.lat;
        const lng = store?.long;
        if (this.map && Number.isFinite(lat) && Number.isFinite(lng) && lat !== 0 && lng !== 0) {
          this.map.panTo({ lat, lng });
          this.map.setZoom(13);
        }
        const endTime = new Date().toISOString();
        const startTime = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
        const id = device_id || plateOrId;
        if (id) {
          if (this.polylines) {
            try { this.polylines.forEach(pl => { if (pl.setMap) pl.setMap(null); }); } catch(e){}
            this.polylines = [];
          }
          // Clear previous vehicle data immediately to avoid showing old colors
          this.setState({ 
            selectedVehicle: (vehicle_plate || '—'),
            selectedDeviceId: device_id || null,
            vehicleChartData: [],
            chartLoadingFromParent: true,
            chartLive: true
          }, () => {
            // Force redraw with gray lines while loading
            if (this.map) this.displayMarkers();
          });
          queryTimestreamData(id, startTime, endTime).then((res) => {
            const points = Array.isArray(res?.rows) ? res.rows
              .filter((item) => (
                Number.isFinite(Number(item.latitude ?? item.lat)) &&
                Number.isFinite(Number(item.longitude ?? item.long)) &&
                Number(item.latitude ?? item.lat) !== 0 &&
                Number(item.longitude ?? item.long) !== 0
              ))
              .map((item) => ({
                lat: Number(item.latitude ?? item.lat),
                lng: Number(item.longitude ?? item.long),
                timestamp: Math.floor(parseTimestreamTime(item.time ?? item.timestamp) / 1000)
              })) : [];
            this.setState((prev) => {
              const stores = Array.isArray(prev.stores) ? [...prev.stores] : [];
              const key = id;
              const idx = stores.findIndex(s => (s.device_id === key || s.NameDevice === key || s.vehicle_plate === key));
              if (idx >= 0) {
                stores[idx] = { ...stores[idx], path: points };
              } else {
                const lastPt = points.length ? points[points.length - 1] : null;
                const base = { device_id: key, NameDevice: key };
                const next = lastPt ? { ...base, path: points, lat: lastPt.lat, long: lastPt.lng, timestamp: lastPt.timestamp, temps: [] } : { ...base, path: points, temps: [] };
                stores.push(next);
              }
              return { stores, vehicleChartData: Array.isArray(res?.measures) ? res.measures : [], chartLoadingFromParent: false };
            }, () => {
              // Force map redraw with new path
              if (this.map) this.displayMarkers();
            });
          }).catch(() => {});
        }
    } 

  updateChartAndPathForRange = (startTimeISO, endTimeISO) => {
      const id = this.state.selectedDeviceId || this.state.selectedVehicle;
      if (!id) return;
      if (this.polylines) {
        try { this.polylines.forEach(pl => { if (pl.setMap) pl.setMap(null); }); } catch(e){}
        this.polylines = [];
      }
      if (this.hoverMarker) { try { this.hoverMarker.setMap(null); } catch(e){} this.hoverMarker = null; }
      const endMs = new Date(endTimeISO).getTime();
      const chartLive = !Number.isFinite(endMs) || Math.abs(Date.now() - endMs) < 2 * 60 * 1000;
      this.setState({ chartLoadingFromParent: true, chartLive });
      queryTimestreamData(id, startTimeISO, endTimeISO).then((res) => {
        const points = Array.isArray(res?.rows) ? res.rows
          .filter((item) => (
            Number.isFinite(Number(item.latitude ?? item.lat)) &&
            Number.isFinite(Number(item.longitude ?? item.long)) &&
            Number(item.latitude ?? item.lat) !== 0 &&
            Number(item.longitude ?? item.long) !== 0
          ))
          .map((item) => ({
            lat: Number(item.latitude ?? item.lat),
            lng: Number(item.longitude ?? item.long),
            timestamp: Math.floor(parseTimestreamTime(item.time ?? item.timestamp) / 1000)
          })) : [];
        this.setState((prev) => {
          const stores = Array.isArray(prev.stores) ? [...prev.stores] : [];
          const key = id;
          const idx = stores.findIndex(s => (s.device_id === key || s.NameDevice === key || s.vehicle_plate === key));
          if (idx >= 0) {
            stores[idx] = { ...stores[idx], path: points };
          } else {
            const lastPt = points.length ? points[points.length - 1] : null;
            const base = { device_id: key, NameDevice: key };
            const next = lastPt ? { ...base, path: points, lat: lastPt.lat, long: lastPt.lng, timestamp: lastPt.timestamp, temps: [] } : { ...base, path: points, temps: [] };
            stores.push(next);
          }
          return { stores, vehicleChartData: Array.isArray(res?.measures) ? res.measures : [], chartLoadingFromParent: false };
        }, () => {
          // Force map redraw with new path
          if (this.map) this.displayMarkers();
        });
      }).catch(() => { this.setState({ chartLoadingFromParent: false }); });
  }

  clearAllPolylines = () => {
      if (this.polylines) {
        try { this.polylines.forEach(pl => { if (pl.setMap) pl.setMap(null); }); } catch(e){}
        this.polylines = [];
      }
      if (this.polylineTooltipOverlay) {
        try { this.polylineTooltipOverlay._visible = false; if (this.polylineTooltipOverlay.draw) this.polylineTooltipOverlay.draw(); } catch(e){}
        this.polylineTooltipOverlay = null;
      }
      if (this.hoverMarker) { try { this.hoverMarker.setMap(null); } catch(e){} this.hoverMarker = null; }
      this.setState(prev => {
        const stores = Array.isArray(prev.stores) ? prev.stores.map(s => {
          const next = { ...s };
          if (Array.isArray(next.path)) next.path = [];
          return next;
        }) : [];
        return { stores, hoverTimestamp: undefined };
      }, () => { try { if (this.map) this.displayMarkers(); } catch(e){} });
  }

    updateHoverOnMap = (tsSec) => {
        const id = this.state.selectedDeviceId || this.state.selectedVehicle;
        if (!id || !this.map || !window.google || !window.google.maps) {
          if (this.hoverMarker) { try { this.hoverMarker.setMap(null); } catch(e){} this.hoverMarker = null; }
          return;
        }
        if (!tsSec && tsSec !== 0) {
          if (this.hoverMarker) { try { this.hoverMarker.setMap(null); } catch(e){} this.hoverMarker = null; }
          return;
        }
        const stores = Array.isArray(this.state.stores) ? this.state.stores : [];
        const idx = stores.findIndex(s => (s.device_id || s.NameDevice) === id);
        const store = idx >= 0 ? stores[idx] : null;
        const path = Array.isArray(store?.path) ? store.path : [];
        if (!path.length) {
          if (this.hoverMarker) { try { this.hoverMarker.setMap(null); } catch(e){} this.hoverMarker = null; }
          return;
        }
        let best = null, diff = Infinity;
        for (let i = 0; i < path.length; i++) {
          const d = Math.abs((path[i].timestamp || 0) - tsSec);
          if (d < diff) { diff = d; best = path[i]; }
        }
        if (!best || !Number.isFinite(best.lat) || !Number.isFinite(best.lng)) {
          if (this.hoverMarker) { try { this.hoverMarker.setMap(null); } catch(e){} this.hoverMarker = null; }
          return;
        }
        const pos = new window.google.maps.LatLng(best.lat, best.lng);
        if (!this.hoverMarker) {
          this.hoverMarker = new window.google.maps.Marker({
            position: pos,
            map: this.map,
            icon: {
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 6,
              strokeColor: '#111',
              strokeOpacity: 0.9,
              fillColor: '#FFD54F',
              fillOpacity: 0.85
            },
            zIndex: 1000
          });
        } else {
          try { this.hoverMarker.setPosition(pos); } catch(e){}
          try { this.hoverMarker.setMap(this.map); } catch(e){}
        }
    }
    
    onMarkerClick = (props, marker, e) => {
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true,
            selectedStoreIndex: props.storeIndex
        });
    }
    
  onMapClicked = (props) => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            })
        }
  };
    displayMarkers = () => {

      // Clear existing markers
      if (this.markers) {
        this.markers.forEach(marker => {
          if (marker.setMap) marker.setMap(null);
          if (marker.map) marker.map = null;
        });
      }
      this.markers = [];
      
      if (this.polylines) {
        this.polylines.forEach(pl => {
          if (pl.setMap) pl.setMap(null);
        });
      }
      this.polylines = [];
      if (this.labelOverlays) {
        this.labelOverlays.forEach(ov => {
          try { if (ov.setMap) ov.setMap(null); else ov.setMap && ov.setMap(null); } catch(e){}
        });
      }
      this.labelOverlays = [];
      
      this.state.stores.forEach((store, index) => {
        let icon_path;
        const currentTimestamp = Math.floor(Date.now() / 1000);
        // Determine if vehicle is online (data less than 1 hour old)
        const isOnline = store.timestamp && (store.timestamp > (currentTimestamp - 60*60));
        
        const v0 = (store && store.temps && store.temps[0] && typeof store.temps[0].value === 'number') ? store.temps[0].value : undefined;
        
        // Select icon based on online status and temperature
        if (isOnline) {
          // Green truck for online vehicles
          if (v0 === undefined) {
            icon_path = truck_green_temp_red;
          } else if (v0 > 10) {
            icon_path = truck_green_temp_red;
          } else if (v0 > 0) {
            icon_path = truck_green_temp_yellow;
          } else {
            icon_path = truck_green_temp_blue;
          }
        } else {
          // Red truck for offline vehicles (will be colored orange via CSS filter)
          if (v0 === undefined) {
            icon_path = truck_red_temp_red;
          } else if (v0 > 10) {
            icon_path = truck_red_temp_red;
          } else if (v0 > 0) {
            icon_path = truck_red_temp_yellow;
          } else {
            icon_path = truck_red_temp_blue;
          }
        }

        if (!Number.isFinite(store.lat) || !Number.isFinite(store.long) || store.lat === 0 || store.long === 0) {
          return;
        }
        
        // Prepare marker creation - for offline vehicles, we'll create an orange-tinted icon
        const createMarker = (iconUrl) => {
          const marker = new window.google.maps.Marker({
            position: { lat: store.lat, lng: store.long },
            icon: {
              url: iconUrl,
              scaledSize: new window.google.maps.Size(40, 40)
            },
            title: (typeof store.velocity === 'number' ? `${store.velocity} km/h` : (store.NameDevice || 'Veículo')),
            map: this.map,
            opacity: 1.0
          });
          
          marker.addListener('click', () => {
            this.onVehicleSelect(store.device_id, store.vehicle_plate || store.NameDevice);
            this.onMarkerClick({
              name: store.NameDevice || store.device_id || 'Veículo',
              storeIndex: index
            }, marker);
          });
          
          this.markers.push(marker);
        };
        
        // For offline vehicles, create orange-tinted icon using canvas
        if (!isOnline) {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            try {
              const canvas = document.createElement('canvas');
              canvas.width = 40;
              canvas.height = 40;
              const ctx = canvas.getContext('2d');
              // Apply sepia and hue-rotate to make red icons appear orange
              ctx.filter = 'sepia(0.3) hue-rotate(10deg) saturate(2.5) brightness(1.05)';
              ctx.drawImage(img, 0, 0, 40, 40);
              createMarker(canvas.toDataURL());
            } catch (e) {
              // Fallback to original icon if canvas fails
              createMarker(icon_path);
            }
          };
          img.onerror = () => createMarker(icon_path);
          img.src = icon_path;
        } else {
          // Online vehicles use normal green icons
          createMarker(icon_path);
        }

        const plateText = store.vehicle_plate || store.NameDevice || store.device_id || '';
        if (plateText) {
          const labelDiv = document.createElement('div');
          labelDiv.textContent = plateText;
          labelDiv.style.position = 'absolute';
          labelDiv.style.transform = 'translate(-50%, -100%)';
          // labelDiv.style.background = 'rgba(255,255,255,0.85)';
          labelDiv.style.padding = '2px 4px';
          labelDiv.style.border = '1px solid #ddd';
          labelDiv.style.borderRadius = '4px';
          labelDiv.style.fontSize = '11px';
          labelDiv.style.color = '#222';
          labelDiv.style.whiteSpace = 'nowrap';
          labelDiv.style.pointerEvents = 'none';
          labelDiv.style.width = '60px';
          labelDiv.style.textAlign = 'center';
          labelDiv.style.overflow = 'hidden';
          labelDiv.style.textOverflow = 'ellipsis';

          const overlay = new window.google.maps.OverlayView();
          overlay.onAdd = function() {
            const panes = this.getPanes();
            panes.overlayImage.appendChild(labelDiv);
          };
          overlay.draw = function() {
            const proj = this.getProjection();
            if (!proj) return;
            const pos = proj.fromLatLngToDivPixel(new window.google.maps.LatLng(store.lat, store.long));
            labelDiv.style.left = pos.x + 'px';
            const offsetY = 40;
            labelDiv.style.top = (pos.y - offsetY) + 'px';
          };
          overlay.onRemove = function() {
            if (labelDiv.parentNode) labelDiv.parentNode.removeChild(labelDiv);
          };
          overlay.setMap(this.map);
          this.labelOverlays.push(overlay);
        }
        
        // Only draw path for selected vehicle, or all vehicles if none selected
        const shouldDrawPath = !this.state.selectedVehicle || 
          (store.device_id === this.state.selectedDeviceId) ||
          (store.vehicle_plate === this.state.selectedVehicle) ||
          (store.NameDevice === this.state.selectedVehicle) ||
          (store.device_id === this.state.selectedVehicle);
        
        if (shouldDrawPath && Array.isArray(store.path) && store.path.length > 1) {
          const path = store.path;
          const tempsData = Array.isArray(this.state.vehicleChartData)
            ? this.state.vehicleChartData
                .filter(m => /temp|temperature|value/i.test(m.measureName))
                .map(m => {
                  const tRaw = m.timestamp !== undefined ? m.timestamp : m.time;
                  let tMs;
                  if (typeof tRaw === 'number') {
                    tMs = tRaw < 1e11 ? tRaw * 1000 : tRaw;
                  } else if (typeof tRaw === 'string') {
                    const s = tRaw.length >= 23 ? tRaw.slice(0, 23) : tRaw;
                    tMs = Date.parse(s);
                  }
                  const tsSec = Math.floor((Number.isFinite(tMs) ? tMs : Date.now()) / 1000);
                  return { ts: tsSec, value: Number(m.value) };
                })
                .sort((a,b) => a.ts - b.ts)
            : [];
          const velData = Array.isArray(this.state.vehicleChartData)
            ? this.state.vehicleChartData
                .filter(m => /velocity|speed|kmh|km\/h/i.test(m.measureName))
                .map(m => {
                  const tRaw = m.timestamp !== undefined ? m.timestamp : m.time;
                  let tMs;
                  if (typeof tRaw === 'number') {
                    tMs = tRaw < 1e11 ? tRaw * 1000 : tRaw;
                  } else if (typeof tRaw === 'string') {
                    const s = tRaw.length >= 23 ? tRaw.slice(0, 23) : tRaw;
                    tMs = Date.parse(s);
                  }
                  const tsSec = Math.floor((Number.isFinite(tMs) ? tMs : Date.now()) / 1000);
                  return { ts: tsSec, value: Number(m.value) };
                })
                .sort((a,b) => a.ts - b.ts)
            : [];
          const colorFor = (v) => (typeof v === 'number' ? (v > 10 ? '#F52C16' : (v > 0 ? '#FFC107' : '#4486E8')) : '#0066FF');
          const nearestTempColor = (ts) => {
            if (!tempsData.length) return '#0066FF';
            let lo = 0, hi = tempsData.length - 1, bestIdx = 0, bestDiff = Infinity;
            while (lo <= hi) {
              const mid = (lo + hi) >> 1;
              const diff = Math.abs(tempsData[mid].ts - ts);
              if (diff < bestDiff) { bestDiff = diff; bestIdx = mid; }
              if (tempsData[mid].ts < ts) lo = mid + 1; else hi = mid - 1;
            }
            return colorFor(tempsData[bestIdx].value);
          };
          const nearestTempValue = (ts) => {
            if (!tempsData.length) return undefined;
            let lo = 0, hi = tempsData.length - 1, bestIdx = 0, bestDiff = Infinity;
            while (lo <= hi) {
              const mid = (lo + hi) >> 1;
              const diff = Math.abs(tempsData[mid].ts - ts);
              if (diff < bestDiff) { bestDiff = diff; bestIdx = mid; }
              if (tempsData[mid].ts < ts) lo = mid + 1; else hi = mid - 1;
            }
            return tempsData[bestIdx].value;
          };
          const nearestVelValue = (ts) => {
            if (!velData.length) return undefined;
            let lo = 0, hi = velData.length - 1, bestIdx = 0, bestDiff = Infinity;
            while (lo <= hi) {
              const mid = (lo + hi) >> 1;
              const diff = Math.abs(velData[mid].ts - ts);
              if (diff < bestDiff) { bestDiff = diff; bestIdx = mid; }
              if (velData[mid].ts < ts) lo = mid + 1; else hi = mid - 1;
            }
            return velData[bestIdx].value;
          };
          if (!this.polylineTooltipOverlay && window.google && window.google.maps) {
            const overlay = new window.google.maps.OverlayView();
            overlay.onAdd = function() {
              const div = document.createElement('div');
              div.style.position = 'absolute';
              div.style.transform = 'translate(-50%, -120%)';
              div.style.fontSize = '11px';
              div.style.lineHeight = '1.2';
              div.style.padding = '2px 6px';
              div.style.background = 'rgba(0,0,0,0.35)';
              div.style.color = '#fff';
              div.style.borderRadius = '4px';
              div.style.pointerEvents = 'none';
              div.style.whiteSpace = 'nowrap';
              this.el = div;
              const panes = this.getPanes();
              panes.overlayMouseTarget.appendChild(div);
            };
            overlay.draw = function() {
              const proj = this.getProjection();
              if (!proj || !this.el || !this._latLng) return;
              const pos = proj.fromLatLngToDivPixel(this._latLng);
              this.el.style.left = pos.x + 'px';
              this.el.style.top = (pos.y - 12) + 'px';
              this.el.style.display = this._visible ? 'block' : 'none';
            };
            overlay.onRemove = function() {
              if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
              this.el = null;
            };
            overlay.setMap(this.map);
            this.polylineTooltipOverlay = overlay;
          }
          for (let i = 1; i < path.length; i++) {
            const a = path[i-1];
            const b = path[i];
            if (!Number.isFinite(a.lat) || !Number.isFinite(a.lng) || !Number.isFinite(b.lat) || !Number.isFinite(b.lng) || a.lat === 0 || a.lng === 0 || b.lat === 0 || b.lng === 0) continue;
            const opacity = Math.max(0.2, 0.95 - (i / path.length) * 0.75);
            // Use gray if no temperature data is loaded, otherwise use temperature-based color
            const segColor = tempsData.length > 0 ? nearestTempColor(b.timestamp) : '#808080';
            const polyline = new window.google.maps.Polyline({
              path: [{ lat: a.lat, lng: a.lng }, { lat: b.lat, lng: b.lng }],
              geodesic: true,
              strokeColor: segColor,
              strokeOpacity: opacity,
              strokeWeight: 3
            });
            polyline.setMap(this.map);
            const showTip = (latLng) => {
              if (!this.polylineTooltipOverlay) return;
              const distA = Math.hypot(a.lat - latLng.lat(), a.lng - latLng.lng());
              const distB = Math.hypot(b.lat - latLng.lat(), b.lng - latLng.lng());
              const ts = distA <= distB ? a.timestamp : b.timestamp;
              const v = nearestTempValue(ts);
              const vel = nearestVelValue(ts);
              const dt = new Intl.DateTimeFormat('pt-BR', {
                day: '2-digit', month: '2-digit',
                hour: '2-digit', minute: '2-digit',
                hour12: false
              }).format(new Date(ts * 1000));
              const html = `${v !== undefined ? `${v}˚C` : '—'}<br/>${vel !== undefined ? `${vel} km/h` : '—'}<br/>${dt}`;
              this.polylineTooltipOverlay._latLng = latLng;
              this.polylineTooltipOverlay._visible = true;
              if (this.polylineTooltipOverlay.el) this.polylineTooltipOverlay.el.innerHTML = html;
              if (this.polylineTooltipOverlay.draw) this.polylineTooltipOverlay.draw();
              this.setState({ hoverTimestamp: ts });
            };
            polyline.addListener('mouseover', (e) => { showTip(e.latLng); });
            polyline.addListener('mousemove', (e) => { showTip(e.latLng); });
            polyline.addListener('mouseout', () => {
              if (this.polylineTooltipOverlay) {
                this.polylineTooltipOverlay._visible = false;
                if (this.polylineTooltipOverlay.draw) this.polylineTooltipOverlay.draw();
              }
              this.setState({ hoverTimestamp: undefined });
            });
            this.polylines.push(polyline);
          }
        }
      });
      
      return null;
    }
    displayTemps = () => {
      if(this.state.stores?.length > 0) {
        if(this.state.stores[0].temps.length > 0) {
          return this.state.stores[0].temps.map((elm, index) => {
                var formatted = new Intl.DateTimeFormat('pt-BR', { //não é pra ser a hora atual. Deve ser store.timestamp aqui
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: false,
                    // timeZone: 'UTC'
                }).format(this.state.stores.timestamp);

                return (
                    <p key={index}>
                        {/* {formatted + ': ' + elm.name + ' = ' + elm.value+' °C'} */}
                        {formatted}
                    </p>
                )
          })
        }
      }
    }

    async componentDidMount(){
        // Timer to update markers every 10 seconds
        this.updateTimer = setInterval(() => {
            this.forceUpdate();
        }, 10000);
        
        this.markers = [];
        this.polylines = [];
        this.labelOverlays = [];
        this._reconnectDelayMs = 5000;
        if (this._reconnectTimer) { try { clearTimeout(this._reconnectTimer); } catch(e){} this._reconnectTimer = null; }
        const scheduleReconnect = () => {
          if (this._reconnectTimer) { try { clearTimeout(this._reconnectTimer); } catch(e){} }
          this._reconnectTimer = setTimeout(() => {
            this._reconnectTimer = null;
            connectPubSub();
          }, this._reconnectDelayMs);
          this._reconnectDelayMs = Math.min(this._reconnectDelayMs * 2, 60000);
        };
        const connectPubSub = () => {
            const processMsg = (value) => {
              try {
                if (this._reconnectTimer) { try { clearTimeout(this._reconnectTimer); } catch(e){} this._reconnectTimer = null; }
                this._reconnectDelayMs = 5000;
                this._lastMessageTs = Date.now();
                const msg = typeof value === 'string' ? JSON.parse(value) : value;
                const hasTemper = Array.isArray(msg.temper) && msg.temper.length > 0;
                if (hasTemper && typeof msg.temper[0].value === 'number' && msg.temper[0].value < -30) return;
                // O "timestamp" do device já é epoch UTC (mesma base do Timestream);
                // "timezone" (-180 no Brasil) é só informativo, não deve ser aplicado.
                const tsRaw = Number(msg.timestamp);
                const tsUtc = Number.isFinite(tsRaw) ? tsRaw : undefined;
                let mensagemRecebida = {
                  NameDevice: msg.NameDevice,
                  device_id: msg.device_id || msg.NameDevice,
                  vehicle_plate: msg.vehicle_plate,
                  long: msg.longitude,
                  lat: msg.latitude,
                  alt: msg.altitude,
                  timestamp: tsUtc,
                  t_0: (Array.isArray(msg.temper) && msg.temper.length > 0 ? msg.temper[0].value : undefined),
                  velocity: msg.velocity,
                  icon_path: [],
                  temps: []
                };
                const names = ['Topo', 'Porta Traseira', 'Meio do Baú', 'Frente (cabine)'];
                if (hasTemper) {
                  mensagemRecebida.temps = msg.temper.slice(0, 4).map((t, i) => ({ name: names[i] || `Sensor ${i+1}`, value: t.value, voltage: t.voltage }));
                } else {
                  mensagemRecebida.temps = [];
                }
                this.setState(prev => {
                  const key = mensagemRecebida.device_id || mensagemRecebida.NameDevice;
                  const stores = Array.isArray(prev.stores) ? [...prev.stores] : [];
                  const idx = stores.findIndex(s => (s.device_id || s.NameDevice) === key);
                  let prevPath = [];
                  if (idx >= 0 && Array.isArray(stores[idx].path)) { prevPath = stores[idx].path.slice(); }
                  const lat = mensagemRecebida.lat;
                  const lng = mensagemRecebida.long;
                  if (Number.isFinite(lat) && Number.isFinite(lng) && lat !== 0 && lng !== 0) {
                    const point = { lat, lng, timestamp: mensagemRecebida.timestamp };
                    const last = prevPath[prevPath.length - 1];
                    if (!last || last.lat !== point.lat || last.lng !== point.lng) {
                      prevPath.push(point);
                      if (prevPath.length > 50) prevPath.shift();
                    }
                  }
                  mensagemRecebida.path = prevPath;
                  // Veículo selecionado no gráfico: acrescenta o ponto na série ao vivo
                  let vehicleChartData = prev.vehicleChartData;
                  const selKey = prev.selectedDeviceId || prev.selectedVehicle;
                  const isSelected = !!selKey && (
                    mensagemRecebida.device_id === selKey ||
                    mensagemRecebida.NameDevice === selKey ||
                    mensagemRecebida.vehicle_plate === selKey
                  );
                  if (isSelected && prev.chartLive && !prev.chartLoadingFromParent && Number.isFinite(mensagemRecebida.timestamp)) {
                    const cur = Array.isArray(prev.vehicleChartData) ? prev.vehicleChartData : [];
                    const tMs = mensagemRecebida.timestamp * 1000;
                    const lastTs = cur.length ? Number(cur[cur.length - 1].timestamp) : -Infinity;
                    // Ignora duplicatas e mensagens fora de ordem
                    if (tMs > lastTs) {
                      const t0 = msg.temper && msg.temper[0] ? msg.temper[0] : {};
                      const added = [];
                      if (typeof t0.value === 'number') {
                        added.push({ timestamp: tMs, measureName: 'temperature', value: Math.round(t0.value * 100) / 100 });
                      }
                      // Mesma escala do Timestream (mV -> V)
                      if (Number.isFinite(Number(t0.voltage))) {
                        added.push({ timestamp: tMs, measureName: 'voltage', value: Number(t0.voltage) / 1000 });
                      }
                      if (Number.isFinite(Number(msg.velocity))) {
                        added.push({ timestamp: tMs, measureName: 'velocity', value: Number(msg.velocity) });
                      }
                      if (added.length) vehicleChartData = cur.concat(added);
                    }
                  }
                  if (idx >= 0) {
                    // Preserve last valid GPS position if new message doesn't have valid GPS
                    const hasValidGPS = Number.isFinite(mensagemRecebida.lat) && 
                                        Number.isFinite(mensagemRecebida.long) && 
                                        mensagemRecebida.lat !== 0 && 
                                        mensagemRecebida.long !== 0;
                    if (!hasValidGPS && Number.isFinite(stores[idx].lat) && stores[idx].lat !== 0) {
                      mensagemRecebida.lat = stores[idx].lat;
                      mensagemRecebida.long = stores[idx].long;
                    }
                    stores[idx] = mensagemRecebida;
                  } else {
                    stores.push(mensagemRecebida);
                  }
                  return vehicleChartData !== prev.vehicleChartData ? { stores, vehicleChartData } : { stores };
                }, () => { try { if (this.map) this.displayMarkers(); } catch(e){} });
              } catch(e){}
            };
            const subscribeTopic = (topic, primary) => {
              const sub = PubSub.subscribe(topic).subscribe({
                next: ({ value }) => { processMsg(value); },
                error: () => {
                  if (primary) {
                    if (this._subscription) { try { this._subscription.unsubscribe(); } catch(e){} }
                    this._subscription = null;
                    scheduleReconnect();
                  } else {
                    if (this._subscription2) { try { this._subscription2.unsubscribe(); } catch(e){} }
                    this._subscription2 = null;
                  }
                },
                complete: () => { if (primary) scheduleReconnect(); }
              });
              if (primary) this._subscription = sub; else this._subscription2 = sub;
              // try { console.log('Subscribed topic:', topic); } catch(e){}
            };
            try {
              Auth.currentSession().then((session) => {
                const endTimeISO = new Date().toISOString();
                const startTimeISO = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
                queryTimestreamDevicesAll(startTimeISO, endTimeISO).then((ids) => {
                  const arr = Array.isArray(ids) ? ids : [];
                  
                  // Load last known positions for all devices
                  if (arr.length > 0) {
                    Promise.all(arr.map(id => queryLastKnownPosition(id)))
                      .then(positions => {
                        const validPositions = positions.filter(p => p !== null);
                        if (validPositions.length > 0) {
                          this.setState(prev => {
                            const stores = Array.isArray(prev.stores) ? [...prev.stores] : [];
                            validPositions.forEach(pos => {
                              const key = pos.device_id;
                              const idx = stores.findIndex(s => (s.device_id === key || s.NameDevice === key || s.vehicle_plate === key));
                              if (idx >= 0) {
                                // Update existing store with last known position if it doesn't have one
                                if (!Number.isFinite(stores[idx].lat) || stores[idx].lat === 0) {
                                  stores[idx] = { ...stores[idx], ...pos };
                                }
                              } else {
                                // Add new store with last known position
                                stores.push(pos);
                              }
                            });
                            return { stores };
                          }, () => {
                            if (this.map) this.displayMarkers();
                          });
                        }
                      })
                      .catch(err => {
                        console.error('Error loading last known positions:', err);
                      });
                  }
                  
                  // Marcus (ou lista vazia): wildcard aberto, todos os tenants.
                  // Demais usuários: um tópico por device da lista do Timestream.
                  const buildTopics = (isMarcus) => (
                    (isMarcus || arr.length === 0) ? [TOPIC_ALL] : arr.map(topicForDevice)
                  );
                  Auth.currentAuthenticatedUser().then((user) => {
                    const topics = buildTopics(user && user.username === 'MarcusAndre');
                    try {
                      // console.log('Timestream devices:', arr);
                      // console.log('MQTT topics to subscribe:', topics);
                    } catch(e){}
                    topics.forEach((t, idx) => subscribeTopic(t, idx === 0));
                  }).catch(() => {
                    let username = null;
                    try { username = session && session.getIdToken && session.getIdToken().payload && (session.getIdToken().payload['cognito:username'] || session.getIdToken().payload.username); } catch(e){}
                    const topics = buildTopics(username === 'MarcusAndre');
                    try {
                      console.log('Timestream devices:', arr);
                      console.log('MQTT topics to subscribe:', topics);
                    } catch(e){}
                    topics.forEach((t, idx) => subscribeTopic(t, idx === 0));
                  });
                }).catch((err) => {
                  try { console.error('Error fetching devices list, subscribing wildcard', err); } catch(e){}
                  subscribeTopic(TOPIC_ALL, true);
                });
              }).catch(() => {
                subscribeTopic(TOPIC_ALL, true);
              });
            } catch(e) {
              subscribeTopic(TOPIC_ALL, true);
            }
        };
        this._lastMessageTs = Date.now();
        this._onVisibilityChange = () => {
          if (!document.hidden) {
            const last = this._lastMessageTs || 0;
            if (Date.now() - last > 30 * 60 * 1000) {
              if (this._subscription) { try { this._subscription.unsubscribe(); } catch(e){} }
              if (this._subscription2) { try { this._subscription2.unsubscribe(); } catch(e){} }
              this._subscription = null;
              this._subscription2 = null;
              if (this._reconnectTimer) { try { clearTimeout(this._reconnectTimer); } catch(e){} this._reconnectTimer = null; }
              this._reconnectDelayMs = 5000;
              connectPubSub();
            }
            this.forceUpdate();
          }
        };
        document.addEventListener('visibilitychange', this._onVisibilityChange);
        window.addEventListener('focus', this._onVisibilityChange);
        this.healthTimer = setInterval(() => {
          const last = this._lastMessageTs || 0;
          if (Date.now() - last > 30 * 60 * 1000) {
            if (this._subscription) { try { this._subscription.unsubscribe(); } catch(e){} }
            if (this._subscription2) { try { this._subscription2.unsubscribe(); } catch(e){} }
            this._subscription = null;
            this._subscription2 = null;
            if (this._reconnectTimer) { try { clearTimeout(this._reconnectTimer); } catch(e){} this._reconnectTimer = null; }
            this._reconnectDelayMs = 5000;
            connectPubSub();
          }
        }, 5 * 60 * 1000);
        connectPubSub();
  }

  componentWillUnmount(){
    if (this.updateTimer) clearInterval(this.updateTimer);
    if (this.mapListeners && window.google && window.google.maps && window.google.maps.event) {
      try { this.mapListeners.forEach(l => window.google.maps.event.removeListener(l)); } catch(e){}
      this.mapListeners = [];
    }
    if (this.labelOverlays) {
      this.labelOverlays.forEach(ov => {
        try { ov.setMap(null); } catch(e){}
      });
      this.labelOverlays = [];
    }
    if (this.markers) {
      this.markers.forEach(marker => {
        if (marker.map) marker.map = null;
      });
      this.markers = [];
    }
    if (this.polylines) {
      this.polylines.forEach(pl => {
        if (pl.setMap) pl.setMap(null);
      });
      this.polylines = [];
    }
    if (this._subscription) { try { this._subscription.unsubscribe(); } catch(e){} this._subscription = null; }
    if (this._subscription2) { try { this._subscription2.unsubscribe(); } catch(e){} this._subscription2 = null; }
    if (this._reconnectTimer) { try { clearTimeout(this._reconnectTimer); } catch(e){} this._reconnectTimer = null; }
    if (this.healthTimer) { try { clearInterval(this.healthTimer); } catch(e){} this.healthTimer = null; }
    if (this._onVisibilityChange) {
      try { document.removeEventListener('visibilitychange', this._onVisibilityChange); } catch(e){}
      try { window.removeEventListener('focus', this._onVisibilityChange); } catch(e){}
      this._onVisibilityChange = null;
    }
    this._reconnectDelayMs = 5000;
  }

  render() {  
    // const {google} = this.props;
    // const {showInfoWindow, activeMarker} = this.state;

    const max = 50
    const min = -30
    function valueToPercent (value) {
      return ((value-min) * 100) / (max-min)
    } 

    setTimeout(() => {
        if(this.state.showingInfoWindow && document.querySelector('#div_chart_term')) {
            // internalMapContainer = document.querySelector(".gm-style-iw-d");
            var chart_term = new ApexCharts(document.querySelector('#div_chart_term'), {
                chart: {
                    height: '100%',
                    id: 'radialBar',
                    type: "radialBar",
                },
                series: [
                    // this.state?.stores[0]?.temps[0]?.value
                    valueToPercent(this.state?.stores[0]?.temps[0]?.value)
                ],
                colors: ["#4486E8"],
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            background: '#EFEFEF',
                            startAngle: -90,
                            endAngle: 90,
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                fontSize: "20px",
                                show: true,
                                formatter: (p) => `${this.state?.stores[0]?.temps[0]?.value} ˚C`
                            }
                        }
                    }
                },
                fill: {
                    type: "gradient",
                    gradient: {
                        shade: "dark",
                        type: "horizontal",
                        gradientToColors: ["#F52C16"],
                        // stops: [-20, 150]
                    }
                },
                stroke: {
                    lineCap: "butt"
                },
                labels: ["Progress"]
            });
            chart_term.render()
        }
    }, 500)
    
    
    if (!this.props.loaded) return <div>Loading...</div>;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, paddingBottom: 16 }}>
          <div style={{ display: 'flex', gap: 12 }}>
            <div style={{ width: '70%', position: 'relative', zIndex: 0, height: 'calc(100vh - 360px)' }}> 
              <Map id="map_canvas"
                google={this.props.google}
                streetViewControl={false}
                fullscreenControl={false}
                zoom={11}
                style={mapStyles}
                initialCenter={MapaCentro}
                onClick={this.onMapClicked}
                options={{ styles: ReducedLabelsMapStyle, mapTypeControl: false, mapTypeId: 'roadmap' }}
                onReady={(mapProps, map) => {
                  this.map = map;
                  if (!this.mapListeners) this.mapListeners = [];
                  this.map.setOptions({ styles: ReducedLabelsMapStyle, mapTypeControl: false, mapTypeId: window.google.maps.MapTypeId.ROADMAP });
                  const zl = window.google.maps.event.addListener(this.map, 'zoom_changed', () => {
                    if (this.map) this.map.setOptions({ styles: ReducedLabelsMapStyle });
                  });
                  const mt = window.google.maps.event.addListener(this.map, 'maptypeid_changed', () => {
                    if (this.map) this.map.setOptions({ styles: ReducedLabelsMapStyle });
                  });
                  this.mapListeners.push(zl, mt);
                  this.displayMarkers();
                }}
                >
              {/* <Chart options={this.state.options} series={this.state.series} type="bar" width={500} height={320} />  */}
              {/* <Marker onClick={this.onMarkerClick} name={'Current location'} /> */}
              {/* <Marker position={MapaCentro} onClick={this.onMarkerClick}/> */}
              {/* <Marker position={this.state.new_markers}/> */}
              {/* <Marker 
                position={MapaCentro}
                onClick={this.onMarkerClick}
              /> */}
              {/* position={{ lat: 48.00, lng: -122.00}} */}
              {this.displayMarkers()}
              {/* {this.createInfoWindow()} */}

              
              </Map>
            </div>
            <div style={{ width: '30%', overflowY: 'auto', padding: 8, position: 'relative', zIndex: 2, background: '#fff', border: '1px solid #ddd', borderRadius: 6, height: 'calc(100vh - 360px)' }}>
              <TrucksTable 
                stores={this.state.stores} 
                onVehicleSelect={this.onVehicleSelect}
                selectedVehicle={this.state.selectedVehicle}
              />
            </div>
          </div>
          <div style={{ width: '100%' }}>
            <VehicleChart selectedVehicle={this.state.selectedVehicle} selectedDeviceId={this.state.selectedDeviceId} initialData={this.state.vehicleChartData} skipInitialFetch={this.state.chartLoadingFromParent} onUpdateRange={this.updateChartAndPathForRange} hoverTimestamp={this.state.hoverTimestamp} onHoverTimestamp={this.updateHoverOnMap} onClearPolylines={this.clearAllPolylines} />
          </div>
        </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyCOvhAuxReFgV0FAgjhbJqFerSsSXgzXDk',
  libraries: ['marker']
})(MapContainer);
